import { successAddBareme } from './../../../../core/models/messages';
import { Component, TemplateRef, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  ValidationErrors,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EsnJobOfferService } from './../../../../core/services/esn-job-offer-service/esn-job-offer.service';
import { SalarieService } from './../../../../core/services/salarie-service/salarie.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
export function duplicateSkillValidator(
  formArray: AbstractControl
): ValidationErrors | null {
  const skills = formArray as FormArray;
  const skillIds = new Set<number>();

  for (let i = 0; i < skills.length; i++) {
    const skillControl = skills.at(i);
    const skillId = skillControl.get('skill_job_id')?.value;

    if (skillId && skillIds.has(skillId)) {
      skillControl.get('skill_job_id')?.setErrors({ duplicateSkill: true });
    } else {
      skillIds.add(skillId);
      skillControl.get('skill_job_id')?.setErrors(null);
    }
  }
  return null;
}
export function duplicateavailabilityValidator(
  formArray: AbstractControl
): ValidationErrors | null {
  const skills = formArray as FormArray;
  const skillIds = new Set<number>();

  for (let i = 0; i < skills.length; i++) {
    const skillControl = skills.at(i);
    const skillId = skillControl.get('availability')?.value;

    if (skillId && skillIds.has(skillId)) {
      skillControl
        .get('availability')
        ?.setErrors({ duplicateavailability: true });
    } else {
      skillIds.add(skillId);
      skillControl.get('availability')?.setErrors(null);
    }
  }
  return null;
}
export function duplicatelanguesValidator(
  formArray: AbstractControl
): ValidationErrors | null {
  const skills = formArray as FormArray;
  const skillIds = new Set<number>();

  for (let i = 0; i < skills.length; i++) {
    const skillControl = skills.at(i);
    const skillId = skillControl.get('language')?.value;

    if (skillId && skillIds.has(skillId)) {
      skillControl.get('language')?.setErrors({ duplicatelanguage: true });
    } else {
      skillIds.add(skillId);
      skillControl.get('language')?.setErrors(null);
    }
  }
  return null;
}

export function duplicateYearExpValidator(
  formArray: AbstractControl
): ValidationErrors | null {
  const skills = formArray as FormArray;
  const skillIds = new Set<number>();

  for (let i = 0; i < skills.length; i++) {
    const skillControl = skills.at(i);
    const skillId = skillControl.get('year_experience')?.value;

    if (skillId && skillIds.has(skillId)) {
      skillControl.get('year_experience')?.setErrors({ duplicateYearExp: true });
    } else {
      skillIds.add(skillId);
      skillControl.get('year_experience')?.setErrors(null);
    }
  }
  return null;
}

@Component({
  selector: 'app-add-bareme',
  templateUrl: './add-bareme.component.html',
  styleUrls: ['./add-bareme.component.css'],
})
export class AddBaremeComponent {
  BaremeForm: FormGroup = this.createBaremeForm();
  @ViewChild('publier', { static: true }) publierModal!: TemplateRef<any>;

  formData = new FormData();
  jobId: any;
  state:any;
  selectedBarem!: number;
  modalRef?: BsModalRef;
  addTestChecked: boolean = true;
  addTestWegestU: boolean = false;
  addTest: boolean = false;
  addScale: boolean = false;
  addComp: boolean = true;
  skillsList: { name_FR: string }[] = [];
  private unsubscribeAll: Subject<void> = new Subject();
  disponibilite = [
    { id: "1", name: 'Immédiate' },
    { id: "3", name: '2 mois' },
    { id: "4", name: '3 mois' },
    { id: "5", name: '4 mois' },
    { id: "6", name: '5 mois' },
  ];
  languages = [
    { id: 1, name: 'Abkhaze' },
    { id: 2, name: 'Afrikaans' },
    { id: 3, name: 'Albanais' },
    { id: 4, name: 'Allemand' },
    { id: 5, name: 'Amharique' },
    { id: 6, name: 'Anglais' },
    { id: 7, name: 'Arabe' },
    { id: 8, name: 'Arménien' },
    { id: 9, name: 'Assamais' },
    { id: 10, name: 'Aymara' },
    { id: 11, name: 'Azéri' },
    { id: 12, name: 'Basque' },
    { id: 13, name: 'Bengali' },
    { id: 14, name: 'Biélorusse' },
    { id: 15, name: 'Birman' },
    { id: 16, name: 'Bosniaque' },
    { id: 17, name: 'Bulgare' },
    { id: 18, name: 'Catalan' },
    { id: 19, name: 'Cebuano' },
    { id: 20, name: 'Chewa' },
    { id: 21, name: 'Chichewa' },
    { id: 22, name: 'Chinois' },
    { id: 23, name: 'Coréen' },
    { id: 24, name: 'Corse' },
    { id: 25, name: 'Croate' },
    { id: 26, name: 'Danois' },
    { id: 27, name: 'Dzongkha' },
    { id: 28, name: 'Espagnol' },
    { id: 29, name: 'Estonien' },
    { id: 30, name: 'Finnois' },
    { id: 31, name: 'Flamand' },
    { id: 32, name: 'Français' },
    { id: 33, name: 'Frison' },
    { id: 34, name: 'Gaélique' },
    { id: 35, name: 'Galicien' },
    { id: 36, name: 'Géorgien' },
    { id: 37, name: 'Grec' },
    { id: 38, name: 'Groenlandais' },
    { id: 39, name: 'Gujarati' },
    { id: 40, name: 'Haoussa' },
    { id: 41, name: 'Hébreu' },
    { id: 42, name: 'Hindi' },
    { id: 43, name: 'Hmong' },
    { id: 44, name: 'Hongrois' },
    { id: 45, name: 'Ibo' },
    { id: 46, name: 'Islandais' },
    { id: 47, name: 'Indonésien' },
    { id: 48, name: 'Inuktitut' },
    { id: 49, name: 'Italien' },
    { id: 50, name: 'Japonais' },
    { id: 51, name: 'Javanais' },
    { id: 52, name: 'Kannada' },
    { id: 53, name: 'Kashmiri' },
    { id: 54, name: 'Kazakh' },
    { id: 55, name: 'Khmer' },
    { id: 56, name: 'Kinyarwanda' },
    { id: 57, name: 'Kirghize' },
    { id: 58, name: 'Kirundi' },
    { id: 59, name: 'Kurde' },
    { id: 60, name: 'Laotien' },
    { id: 61, name: 'Latin' },
    { id: 62, name: 'Letton' },
    { id: 63, name: 'Lituanien' },
    { id: 64, name: 'Luxembourgeois' },
    { id: 65, name: 'Macédonien' },
    { id: 66, name: 'Malais' },
    { id: 67, name: 'Malayalam' },
    { id: 68, name: 'Malgache' },
    { id: 69, name: 'Maltais' },
    { id: 70, name: 'Maori' },
    { id: 71, name: 'Marathi' },
    { id: 72, name: 'Mongol' },
    { id: 73, name: 'Néerlandais' },
    { id: 74, name: 'Népalais' },
    { id: 75, name: 'Norvégien' },
    { id: 76, name: 'Ouzbek' },
    { id: 77, name: 'Pachtou' },
    { id: 78, name: 'Papiamento' },
    { id: 79, name: 'Pashto' },
    { id: 80, name: 'Persan (farsi)' },
    { id: 81, name: 'Polonais' },
    { id: 82, name: 'Portugais' },
    { id: 83, name: 'Punjabi' },
    { id: 84, name: 'Quechua' },
    { id: 85, name: 'Roumain' },
    { id: 86, name: 'Russe' },
    { id: 87, name: 'Somali' },
    { id: 88, name: 'Samoan' },
    { id: 89, name: 'Sanskrit' },
    { id: 90, name: 'Serbe' },
    { id: 91, name: 'Sesotho' },
    { id: 92, name: 'Shona' },
    { id: 93, name: 'Sindhi' },
    { id: 94, name: 'Slovaque' },
    { id: 95, name: 'Slovène' },
    { id: 96, name: 'Sotho' },
    { id: 97, name: 'Soundanais' },
    { id: 98, name: 'Suédois' },
    { id: 99, name: 'Swahili' },
    { id: 100, name: 'Tadjik' },
  ];

  expYears = [
    { id: 1, name: '0-1', value: '1' },
    { id: 2, name: '1-2', value: '2' },
    { id: 3, name: '2-5', value: '3' },
    { id: 4, name: '5-10', value: '4' },
    { id: 5, name: '+10', value: '5' },
  ];

  constructor(
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private toastrService: ToastrService,
    private spinner: NgxSpinnerService,
    private jobOfferService: EsnJobOfferService,
    private route: Router,
    private salarieService: SalarieService,
    private modalBsService: BsModalService,
    private router: Router


  ) {}

  ngOnInit() {
    this.getListSkills();
    this.getId();
    if (this.state === 'update' || this.state == 0) {
      this.getBarem();
    }
    this.hasDuplicateavaibilityErrors();
  }

  /* get id  from route */
  getId() {
    this.activatedRoute.paramMap.subscribe({
      next: (params: any) => {
        this.jobId = params.params['jobId'];
        this.state = params.params['state'];
      },
    });
  }

  hasDuplicateSkillErrors(): boolean {
    const skillScoreArray = this.BaremeForm.get('skill_scores') as FormArray;

    const skillJobIds = skillScoreArray.controls.map(
      (control) => control.get('skill_job_id')!.value
    );

    const duplicates = skillJobIds.filter(
      (id, index) => id && skillJobIds.indexOf(id) !== index
    );

    return duplicates.length > 0;
  }

  hasDuplicateavaibilityErrors(): boolean {
    const skillScoreArray = this.BaremeForm.get(
      'availability_scores'
    ) as FormArray;
    const skillJobIds = skillScoreArray.controls.map(
      (control) => control.get('availability')!.value
    );

    const duplicates = skillJobIds.filter(
      (id, index) => id && skillJobIds.indexOf(id) !== index
    );

    return duplicates.length > 0;
  }

  hasDuplicatelangueErrors(): boolean {
    const skillScoreArray = this.BaremeForm.get('language_scores') as FormArray;

    const skillJobIds = skillScoreArray.controls.map(
      (control) => control.get('language')!.value
    );

    const duplicates = skillJobIds.filter(
      (id, index) => id && skillJobIds.indexOf(id) !== index
    );

    return duplicates.length > 0;
  }

  hasDuplicateExpYearsErrors(): boolean {
    const skillScoreArray = this.BaremeForm.get('experience_scores') as FormArray;

    const skillJobIds = skillScoreArray.controls.map(
      (control) => control.get('year_experience')!.value
    );
    const duplicates = skillJobIds.filter(
      (id, index) => id && skillJobIds.indexOf(id) !== index
    );

    return duplicates.length > 0;
  }

  getBarem() {
    this.spinner.show();
    this.jobOfferService
      .getBarem(this.jobId)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res: any) => {          
          this.selectedBarem = res.data;
          this.BaremeForm = this.createBaremeForm(this.selectedBarem);
          this.BaremeForm.get('test_qcm_score')?.setValue(
            res.data?.test_qcm_score
              ? res.data.test_qcm_score?.coef
              : null
          );
          this.spinner.hide();
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
  createFormLangues(data?: any): FormGroup {
    const formGroup = this.formBuilder.group({
      language: [data ? data.language : null],
      coef: [data ? String(data.coef) : null],
    });
    if (formGroup.get('language')!.value == null) {
      formGroup.get('coef')!.disable();
    }
    formGroup.get('language')!.valueChanges.subscribe((value) => {
      if (value) {
        formGroup.get('coef')!.enable();
      } else {
        formGroup.get('coef')!.disable();
        formGroup.get('coef')!.reset();
      }
    });

    return formGroup;
  }

  createFormSkills(data?: any): FormGroup {
    const formGroup = this.formBuilder.group({
      skill_job_id: [data ? data.skill_job_id : null],
      coef: [data ? String(data.coef) : null],
    });
    if (formGroup.get('skill_job_id')!.value == null) {
      formGroup.get('coef')!.disable();
    }
    formGroup.get('skill_job_id')!.valueChanges.subscribe((value) => {
      if (value) {
        formGroup.get('coef')!.enable();
      } else {
        formGroup.get('coef')!.disable();

        formGroup.get('coef')!.reset();
      }
    });

    return formGroup;
  }
  createFormAvailability(data?: any): FormGroup {
    const formGroup = this.formBuilder.group({
      availability: [data ? data.availability : null],
      coef: [data ? String(data.coef) : null],
    });
    if (formGroup.get('availability')!.value == null) {
      formGroup.get('coef')!.disable();
    }
    formGroup.get('availability')!.valueChanges.subscribe((value) => {
      if (value) {
      formGroup.get('coef')!.enable();
      } else {
       formGroup.get('coef')!.disable();
        formGroup.get('coef')!.reset();
      }
    });

    return formGroup;
  }
  createFormExperience(data?: any): FormGroup {  
    const formGroup = this.formBuilder.group({
      year_experience: [data ? String(data.year_experience) : null],
      coef: [data ? String(data.coef) : null],
    });
    if (formGroup.get('year_experience')!.value == null) {
      formGroup.get('coef')!.disable();
    }
    formGroup.get('year_experience')!.valueChanges.subscribe((value) => {
      if (value) {
        formGroup.get('coef')!.enable();
      } else {
        formGroup.get('coef')!.disable();
        formGroup.get('coef')!.reset();
      }
    });

    return formGroup;
  }

  addSkills() {
    const skills = this.BaremeForm.get('skill_scores') as FormArray;
    skills.push(this.createFormSkills());
  }
  addLangues() {
    const language_scores = this.BaremeForm.get('language_scores') as FormArray;
    language_scores.push(this.createFormLangues());
  }
  addAvailability() {
    const availability_scores = this.BaremeForm.get(
      'availability_scores'
    ) as FormArray;
    availability_scores.push(this.createFormAvailability());
  }

  addYearExp() {
    const experience_scores = this.BaremeForm.get('experience_scores') as FormArray;
    experience_scores.push(this.createFormExperience());
  }

  get skillsControls(): AbstractControl<any, any>[] {
    return (this.BaremeForm.get('skill_scores') as FormArray)?.controls || [];
  }
  get availability_scoreControls(): AbstractControl<any, any>[] {
    return (
      (this.BaremeForm.get('availability_scores') as FormArray)?.controls || []
    );
  }

  get langueControls(): AbstractControl<any, any>[] {
    return (this.BaremeForm.get('language_scores') as FormArray)?.controls || [];
  }

  get yearExpControls(): AbstractControl<any, any>[] {
    return (this.BaremeForm.get('experience_scores') as FormArray)?.controls || [];
  }

  removescoreQCM(index: number) {
    const ScoreQCM = this.BaremeForm.get('test_qcm_score') as FormArray;
    ScoreQCM.removeAt(index);
  }
  removeSkills(index: number) {
    const skills = this.BaremeForm.get('skill_scores') as FormArray;
    skills.removeAt(index);
  }
  removeAvailability(index: number) {
    const availability_scores = this.BaremeForm.get(
      'availability_scores'
    ) as FormArray;
    availability_scores.removeAt(index);
  }
  removeLangue(index: number) {
    const language_scores = this.BaremeForm.get('language_scores') as FormArray;
    language_scores.removeAt(index);
  }

  removeYearExp(index: number) {
    const year_exp_score = this.BaremeForm.get('experience_scores') as FormArray;
    year_exp_score.removeAt(index);
  }
  
  showbutton: boolean = false;
  isFormValid(): boolean {
    // Validation pour chaque groupe de contrôles
    const skillsValid = this.skillsControls.some((control) => {
      const skillSelected = control.get('skill_job_id')?.value;
      const coefFilled = control.get('coef')?.value;
      return skillSelected && coefFilled !== null && coefFilled !== '';
    });

    const availabilityValid = this.availability_scoreControls.some(
      (control) => {
        const availabilitySelected = control.get('availability')?.value;
        const coefFilled = control.get('coef')?.value;
        return availabilitySelected && coefFilled !== null && coefFilled !== '';
      }
    );
    const experienceValid = this.yearExpControls.some((control) => {
      const yearExperience = control.get('year_experience')?.value;
      const coefFilled = control.get('coef')?.value;
      return yearExperience && coefFilled !== null && coefFilled !== '';
    });

    const languageValid = this.langueControls.some((control) => {
      const languageSelected = control.get('language')?.value;
      const coefFilled = control.get('coef')?.value;
      return languageSelected && coefFilled !== null && coefFilled !== '';
    });

    const testQCMScore = this.BaremeForm.get('test_qcm_score')?.value ?? null;
    
    const isTestQCMScoreValid = testQCMScore !== null && testQCMScore !== '';

    // Vérifier que toutes les saisies qui ont des valeurs ont des coefs valides
    const areAllCoefficientsValid = [
      ...this.skillsControls,
      ...this.availability_scoreControls,
      ...this.langueControls,
      ...this.yearExpControls,
    ].every((control) => {
      const coefControl = control.get('coef');
      const valueControl =
        control.get('skill_job_id')?.value ||
        control.get('availability')?.value ||
        control.get('year_experience')?.value ||
        control.get('language')?.value;
      // Si une valeur est entrée, le coefficient doit être non nul et non vide
      return valueControl
        ? coefControl?.value !== null && coefControl?.value !== ''
        : true;
    });

    // Le formulaire est valide si au moins une section est remplie correctement et tous les coefficients requis sont présents
    return (
      (skillsValid || availabilityValid || experienceValid || languageValid || isTestQCMScoreValid) &&
      areAllCoefficientsValid
    );
  }

  createBaremeForm(data?: any) {
    const skillScoreArray = this.formBuilder.array(
      Array.isArray(data?.skill_scores) && data?.skill_scores.length
        ? data.skill_scores.map((item: any) => this.createFormSkills(item))
        : [this.createFormSkills()]
    );

    // Ajout de la validation pour les compétences dupliquées
    skillScoreArray.setValidators(duplicateSkillValidator);
    const skillavaibilityArray = this.formBuilder.array(
      Array.isArray(data?.availability_scores) && data?.availability_scores.length
        ? data.availability_scores.map((item: any) =>
            this.createFormAvailability(item)
          )
        : [this.createFormAvailability()]
    );

    skillavaibilityArray.setValidators(duplicateavailabilityValidator);

    const skilllanguersArray = this.formBuilder.array(
      Array.isArray(data?.language_scores) && data?.language_scores.length
        ? data.language_scores.map((item: any) => this.createFormLangues(item))
        : [this.createFormLangues()]
    );

    // Ajout de la validation pour les compétences dupliquées
    skilllanguersArray.setValidators(duplicatelanguesValidator);

    const skillYearExpArray = this.formBuilder.array(
      Array.isArray(data?.experience_scores) && data?.experience_scores.length
        ? data.experience_scores.map((item: any) => this.createFormExperience(item))
        : [this.createFormExperience()]
    );
    skillYearExpArray.setValidators(duplicateYearExpValidator);
    skillYearExpArray.setValidators(duplicateYearExpValidator);

    skillYearExpArray.setValidators(duplicateYearExpValidator);   

    return this.formBuilder.group({
      job_offer_id: [data ? data.job_offer_id : ''],
      test_qcm_score: [data ? data.test_qcm_score : null],
      skill_scores: skillScoreArray,
      availability_scores: skillavaibilityArray,
      language_scores: skilllanguersArray,
      experience_scores: skillYearExpArray,
    });
  }
  convertCoefToString(data: any): any {
    if (data.skill_scores) {
      data.skill_scores = data.skill_scores.map((item: any) => ({
        ...item,
        coef: String(item.coef),
      }));
    }

    if (data.availability_scores) {
      data.availability_scores = data.availability_scores.map((item: any) => ({
        ...item,
        coef: String(item.coef),
      }));
    }

    if (data.language_scores) {
      data.language_scores = data.language_scores.map((item: any) => ({
        ...item,
        coef: String(item.coef),
      }));
    }
    
    if (data?.experience_scores) {
      data.experience_scores = data.experience_scores.map((item: any) => ({
        ...item,
        coef: String(item.coef),
      }));
    }
    return data;
  }
  cleanArray(array: any[]): any[] {
    if (array && Array.isArray(array)) {
      return array.filter(
        (item) =>
          item !== null &&
          item !== undefined &&
          item.coef !== 'undefined' &&
          item.coef !== 'null'
      );
    }
    return [];
  }

  addBareme() {
    if (this.jobId !== null) {
      this.BaremeForm.patchValue({ job_offer_id: this.jobId });
    }

    let baremeData = this.BaremeForm.value;
    baremeData = this.convertCoefToString(baremeData);
    
    // Nettoyer les tableaux en supprimant les valeurs nulles ou non valides
    baremeData.skill_scores = this.cleanArray(baremeData.skill_scores);
    baremeData.availability_scores = this.cleanArray(
      baremeData.availability_scores
    );
    baremeData.language_scores = this.cleanArray(baremeData.language_scores);
    baremeData.experience_scores = this.cleanArray(baremeData.experience_scores);
    const cleanedObject = this.removeNullValues(baremeData);

    this.jobOfferService
      .addBareme(cleanedObject)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          if (res?.status == 200 ) {
            this.toastrService.success(successAddBareme);
            if( this.state == 0){
              setTimeout(() => {
                this.openModal(this.publierModal);
              }, 2000);
            }
            if( this.state !=0){
            this.route.navigateByUrl('/offres-emploi/liste-offres-emploi');
            }
            this.showbutton = true;
          }
          
        },
        error: (err) => {
          if (
            err.error &&
            err.error.message == 'Duplicate skills values found'
          ) {
            this.toastrService.error(
              'Des compétences en double ont été détectées.'
            );
          }
          if (
            err.error &&
            err.error.message == 'Duplicate languages values found'
          ) {
            this.toastrService.error(
              'Des languages en double ont été détectées.'
            );
          }

          if (
            err.error &&
            err.error.message == 'Duplicate availabilities values found'
          ) {
            this.toastrService.error(
              'Des Disponibilités en double ont été détectées.'
            );
          }
          if (
            err.error &&
            err.error.message &&
            err.error.message.availability &&
            err.error.message.availability[1] ==
              'The availability field is required.'
          ) {
            this.toastrService.error(
              'Il faut ajouter au moins une disponibilité'
            );
          } else if (
            err.error &&
            err.error.message &&
            err.error.message.language &&
            err.error.message.language[1] == 'The language field is required.'
          ) {
            this.toastrService.error('Il faut ajouter au moins une langue');
          } else if (
            err.error &&
            err.error.message &&
            err.error.message.skill_job_id &&
            err.error.message.skill_job_id[0] ==
              'The skill job id field is required.'
          ) {
            this.toastrService.error('Il faut ajouter au moins une compétence');
          }
          // this.toastrService.error(serverError)
        },
      });
  }
  onConfirm() {
    if (this.addTestChecked && this.addTestWegestU) {
      this.router.navigate(['/offres-emploi/add-test-wegestu'],
        {
          queryParams: { jobId: this.jobId, state:0 },
          state: {  testType: 'NO_TEST' },
        });
    } else if (this.addTestChecked && this.addTest) {
      this.router.navigate(['/offres-emploi/add-test'],
        {
          queryParams: { jobId: this.jobId, state:0 },
          state: {  testType: 'NO_TEST' },
        }
      );
    }
    
    this.closeModal()
  }
 
  closeModal() {
    this.modalRef?.hide();
  }
  getListSkills() {
    this.salarieService
      .getSkillsJobs()
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.skillsList = res.data;
        },
        error: () => {},
      });
  }
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalBsService.show(template, { backdrop: 'static' });
    
  }
  onAddTestChange() {
    if (this.addTestChecked) {
        this.addScale = false;  
    }
}
closeModalAndRedirect() {
  // Réinitialiser les états des cases à cocher
  this.addScale = false;
  this.addTestChecked = false;
  this.addTest = false;
  this.addTestWegestU = false;

  // Fermer la modale et rediriger
  this.modalRef?.hide();
  this.router.navigate(['/offres-emploi/liste-offres-emploi']);
}  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }

  checkInputsDuplication(): boolean{
    return this.hasDuplicateSkillErrors() || this.hasDuplicateavaibilityErrors()|| 
    this.hasDuplicatelangueErrors() || this.hasDuplicateExpYearsErrors()
  }

  cancelScale(){
    this.router.navigate([
      `/offres-emploi/liste-offres-emploi`,
    ]);
  }

  removeNullValues(obj: any): any {
    const result = { ...obj }; // Clone the object to avoid mutating the original

    // Iterate over the object keys
    for (const key in result) {
      if (result[key] === null) {
        delete result[key];
      }
    }
  
    return result;
  }
}
